<form [formGroup]="dietenFg">
    <div formArrayName="dieten">
        <div *ngFor="let item of dieten.controls; let i = index; "
             [formGroupName]="i" class="row">
            <snelstart-ui-select-form-control
                    (change)="saveForm()"
                    [label]="i === 0 ? 'Dieet > Aandoening' : ''"
                    [options]="aandoeningen"
                    class="col-auto custom-input-250"
                    formControlName="aandoening"
                    label="Aandoening"
            >
            </snelstart-ui-select-form-control>

            <div class="row col-auto" formGroupName="periode">
                <snelstart-ui-date-form-control (change)="saveForm();"
                                                [label]="i === 0 ? 'Begindatum' : ''"
                                                class="col-auto custom-input-150"
                                                formControlName="begindatum"
                                                id="begindatum"
                >
                </snelstart-ui-date-form-control>
                <snelstart-ui-date-form-control (change)="saveForm();"
                                                [label]="i === 0 ? 'Einddatum' : ''"
                                                class="col-auto custom-input-150"
                                                formControlName="einddatum"
                                                id="einddatum"
                >
                </snelstart-ui-date-form-control>
            </div>
            <div class="row col-auto">
            <snelstart-ui-button (click)="verwijderRijDieten(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                                 icon="trash"
                                 id="buttonDeleteKosten"
                                 size="medium"
                                 type="secondary">
            </snelstart-ui-button>
        </div>
        </div>
    </div>
</form>

<div *ngIf="dieten.length === 0">
    <snelstart-ui-button (click)="addRijDieten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Dieet
    </snelstart-ui-button>
</div>
<div *ngIf="dieten.length > 0">
    <snelstart-ui-button (click)="addRijDieten()" class="snelstart-ui-button pb-3" icon="plus"
                         type="link">Dieet toevoegen
    </snelstart-ui-button>
</div>




